import Vue from 'vue';

Vue.mixin({
  methods: {
    track,
    trackClick(eventId, object = {}) {
      track({ event_id: eventId, etracker_event_action: 'click', ...object });
    },
    trackBoosterMultiplier(eventId, productMultiplier) {
      track({
        event_id: eventId,
        etracker_event_action: 'click',
        product_multiplier: productMultiplier
      });
    },
    /**
     * Tracking for Onlinebooster drawing levels
     * @param {object} drawingLevel
     * @param {'basis'|'zusatz'} category
     */
    trackDrawingBoosterClick(drawingLevel, category) {
      let eventId;
      const price = drawingLevel.price.toFixed(2).replace('.00', '');

      switch (category) {
        case 'basis':
          eventId = `pk_lotterie_5s-ob-konfi_mitte_kachel_h_${price}`;
          break;
        case 'zusatz':
          eventId = `pk_lotterie_5s-ob-konfi_mitte_kachel_zc_${price}`;
          break;
      }

      if (!eventId) {
        console.warn('Missing event id, unknown category', category);
        return;
      }

      track({ event_id: eventId, etracker_event_action: 'click' });
    },

    trackAddProduct(eventName = 'add_to_cart') {
      let product = window.utag_data;
      const digitElements = document.querySelectorAll('.digit');
      const lotNumber = Array.from(digitElements)
        .map((digit) => digit.textContent.trim())
        .join('');
      const isPdfChecked = document.querySelector('input[value="Pdf"]:checked');

      const selectedVariants = this.data.categoryAreaContent
        .filter((category) => category.levels) // Only categories with levels
        .flatMap((category) =>
          category.levels.filter((level) => level.isSelected)
        ) // Get selected levels
        .map((level) => `${level.productMatrixValue.slice(0, 2)}${level.price}`) // Concatenate first 2 letters of productMatrixValue with price
        .join('-'); // Concatenate names with a hyphen

      const selectedBundle = this.data.bundles.find(
        (bundle) => bundle.isSelected
      );
      const productBundleVariant = selectedBundle
        ? [`${selectedBundle.name}${parseInt(selectedBundle.prize)}`]
        : ['Standard'];
      const productBundle =
        productBundleVariant[0] === 'Standard' ? ['Standard'] : ['Bundle'];

      product.product_quantity = 1;
      product.product_ids = [lotNumber];
      product.product_categories = ['MICH'];
      product.product_shipping_type = isPdfChecked ? ['mail'] : ['brief'];
      product.product_shipping_target = ['kaeufer'];
      product.product_play_date = ['kauefer'];
      product.product_variants = [selectedVariants];
      product.product_bundle = productBundle;
      product.product_bundle_variant = productBundleVariant;

      track({
        event_id: eventName,
        etracker_event_action: 'click',
        ...product
      });
    }
  }
});

export function track(event) {
  let method = 'link';

  if (!window.utag || !window.utag.link || !window.utag.view) {
    return console.warn(
      `utag not available. Cannot track via utag.${method}(): `,
      event
    );
  }

  window.utag[method](event);
}
